import { createSelector } from '@reduxjs/toolkit';

export const loaderStatus = (state: ReturnType<any>) => state.loader.value;

export const loaderSelector = createSelector(loaderStatus, (state) => state);
